export default __webpack_public_path__ + "static/media/share.ada619a8.svg";